export const recordExperimentView = (state, { id }) => ({
  ...state,
  // eslint-disable-next-line no-unsafe-optional-chaining
  viewedOnPage: state?.viewedOnPage?.length ? [...state?.viewedOnPage, id] : [id],
});
